// extracted by mini-css-extract-plugin
export default {"row":"row__2osdK","termSalesHeader":"termSalesHeader__1cYBX","showTermSalesButton":"showTermSalesButton__3lpl-","termSalesMovableElement":"termSalesMovableElement__13Qqo","termSalesOpened":"termSalesOpened__1vR0f","termSales":"termSales__1lWF9","switchInput":"switchInput__1TgIX","switch":"switch__3FuJa","slider":"slider__1nLto","round":"round__15v-c","modal":"modal__ZW3A0","show":"show__tUo5J","termWrapper":"termWrapper__IPj9t","overlay":"overlay__3wtN0"};
    if(module.hot) {
      // 1713425491402
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  